import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import config from '../config';

function PromoterList() {
    const [promoters, setPromoters] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');
    const [filterVerified, setFilterVerified] = useState('');

    useEffect(() => {
        document.title = 'SHARC - Promoters';
        axios.get(`${config.API_URL}/promoters`)
            .then(res => {
                setPromoters(res.data.promoters || []);
                setLoading(false);
            })
            .catch(() => setLoading(false));
        return () => { document.title = 'SHARC - Shows Archive'; };
    }, []);

    const q = search.toLowerCase();
    const filtered = promoters.filter(p => {
        if (search && ![p.name, p.city, p.state, p.country].some(v => v && v.toLowerCase().includes(q))) return false;
        if (filterVerified === 'verified' && !p.sharc_id) return false;
        if (filterVerified === 'unverified' && p.sharc_id) return false;
        return true;
    });

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                <h1 style={styles.title}>Promoters</h1>
                <Link to="/add-promoter" style={styles.addButton}>+ Add Promoter</Link>
            </div>

            <div style={styles.filterRow}>
                <input
                    type="text"
                    placeholder="Search promoters..."
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                    style={styles.search}
                />
                <select
                    value={filterVerified}
                    onChange={e => setFilterVerified(e.target.value)}
                    style={styles.verifiedSelect}
                >
                    <option value="">All</option>
                    <option value="verified">Verified</option>
                    <option value="unverified">Unverified</option>
                </select>
            </div>

            {loading ? (
                <div style={styles.message}>Loading...</div>
            ) : filtered.length === 0 ? (
                <div style={styles.message}>{(search || filterVerified) ? 'No promoters match your search.' : 'No promoters yet.'}</div>
            ) : (
                <div style={styles.tableContainer}>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.th}>Name</th>
                                <th style={styles.th}>City</th>
                                <th style={styles.th}>State</th>
                                <th style={styles.th}>Country</th>
                                <th style={styles.th}>Events</th>
                                <th style={styles.th}>Festivals</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.map((p, idx) => (
                                <tr key={p.id} style={idx % 2 === 0 ? styles.trEven : styles.trOdd}>
                                    <td style={styles.td}>
                                        <Link to={`/promoters/${p.slug || p.id}`} style={styles.link}>{p.name}</Link>
                                    </td>
                                    <td style={styles.td}>{p.city || '—'}</td>
                                    <td style={styles.td}>{p.state || '—'}</td>
                                    <td style={styles.td}>{p.country || '—'}</td>
                                    <td style={styles.td}>{p.event_count || 0}</td>
                                    <td style={styles.td}>{p.festival_count || 0}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

const styles = {
    title: { fontSize: '32px', fontWeight: 'bold', color: '#e0e0e0', margin: 0 },
    addButton: { backgroundColor: '#bb86fc', color: '#121212', border: 'none', borderRadius: '4px', padding: '8px 18px', fontSize: '14px', fontWeight: 'bold', textDecoration: 'none' },
    filterRow: { display: 'flex', gap: '10px', marginBottom: '20px', alignItems: 'center' },
    search: { backgroundColor: '#2c2c2c', border: '1px solid #444', borderRadius: '6px', padding: '10px 14px', fontSize: '14px', color: '#e0e0e0', flex: 1, boxSizing: 'border-box' },
    verifiedSelect: { backgroundColor: '#2c2c2c', border: '1px solid #444', borderRadius: '6px', padding: '10px 14px', fontSize: '14px', color: '#e0e0e0', minWidth: '140px', cursor: 'pointer' },
    tableContainer: { overflowX: 'auto' },
    table: { width: '100%', borderCollapse: 'collapse', fontSize: '14px' },
    th: { textAlign: 'left', padding: '10px 16px', color: '#aaa', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: '1px solid #333', whiteSpace: 'nowrap' },
    td: { padding: '11px 16px', color: '#e0e0e0', borderBottom: '1px solid #222' },
    trEven: { backgroundColor: '#1e1e1e' },
    trOdd: { backgroundColor: '#1a1a1a' },
    link: { color: '#bb86fc', textDecoration: 'none' },
    message: { textAlign: 'center', color: '#aaa', fontSize: '16px', padding: '60px 0' },
};

export default PromoterList;
